import { FormInstance } from "antd";
import { setTimeWithSeconds } from "../../helpers";
import dayjs from 'dayjs';

export const setExamPeriodFormValues = (
    groupSettingsForm: FormInstance,
    examPeriod: any
) => {
    const tempExamPeriod = {
        ...examPeriod
    }
    delete tempExamPeriod.time;
    delete tempExamPeriod.date;

    // groupSettingsForm.setFieldValue('type', "Online");
    
    groupSettingsForm.setFieldsValue(tempExamPeriod)
    
    if (examPeriod.time) {
      groupSettingsForm.setFieldsValue({
        time: setTimeWithSeconds(examPeriod.time),
        date: dayjs(examPeriod.date)
      });
    }
}